<template>
  <div class="wrapper">
    <p class="subtitle"> Request access for IFRS </p>

    <div class="input-group label hint bm">
      <label> Name and Surname </label>
      <input v-model="name" placeholder="Enter your name and your last name" @input="checkName">
      <span class="iconify icon icon:bx:bx-face"></span>
      <!-- <span class="input-hint"> This is a hint </span> -->
    </div>

    <div class="input-group label hint bm" :class="[isEmailValid()]">
      <label> Email </label>
      <input v-model="email" type="email" placeholder="Enter your email">
      <span class="iconify icon icon:ic:sharp-alternate-email"></span>
      <!-- <span class="input-hint"> This is a hint </span> -->
    </div>

    <div class="input-group label hint bm">
      <label> Company name </label>
      <input v-model="company" type="text" placeholder="Enter name of company">
      <span class="iconify icon icon:maki:building-alt1-11"></span>
      <!-- <span class="input-hint"> This is a hint </span> -->
    </div>

    <div class="input-group label hint bm">
      <label> VAT Number </label>
      <input v-model="vat" type="text" placeholder="Enter company VAT number">
      <span class="iconify icon icon:mdi:alpha-v-circle-outline"></span>
      <!-- <span class="input-hint"> This is a hint </span> -->
    </div>

    <div class="input-group label hint bm">
      <label> Registration number </label>
      <input v-model="reg" type="text" placeholder="Enter company registration number">
      <span class="iconify icon icon:uil:registered"></span>
      <!-- <span class="input-hint"> This is a hint </span> -->
    </div>

    <div class="input-group label hint bm">
      <label> Company address </label>
      <input v-model="address" type="text" placeholder="Enter company adress">
      <span class="iconify icon icon:whh:address"></span>
      <!-- <span class="input-hint"> This is a hint </span> -->
    </div>

    <input type="radio" v-model="dateFormat" value="dd/mm/yyyy" checked>
    <input type="radio" v-model="dateFormat" value="mm/dd/yyyy">
    {{dateFormat}}

    <div class="input-group label hint bm">
      <label> {{label}} </label>
      <!-- <input v-model="dateTest" type="text" placeholder="Enter date" masked="true" v-mask="'##/##/####'"> -->
      <the-mask v-model="dateTest" mask="##/##/####" type="text" :placeholder="dateFormat"></the-mask>
      <span class="iconify icon icon:whh:notesdatealt"></span>
      <span class="input-hint">(to change date format go to settings)</span>  
    </div>
    {{ dateTest }}

    <p v-if="errors.length">
      <b><span class="bm">Please correct the following error(s):</span></b>
      <ul>
        <li class="error" v-for="(error, i) in errors" :key="i">{{ error }}</li>
      </ul>
    </p>

    <input type="submit" value="Request access" class="btn" @click="checkForm()">
  </div>
</template>
<script>
// import MaskedInput from 'vue-masked-input'
import axios from 'axios'
import {TheMask} from 'vue-the-mask'
// import {mask} from 'vue-the-mask'


export default {
  // directives: {mask},
  components: {
    // MaskedInput
    TheMask
  },
  data() {
    return {
      errors: [],
      name: null,
      email: "", // email can't be null as on load it receives class error (look at isEmailValid function)
      company: null,
      vat: null,
      reg: null,
      address: null,
      dateTest: null,
      label: "Day/Month/Year",
      dateFormat: "dd/mm/yyyy"
    }
  },
  watch: {
    dateFormat: function() {
      if(this.dateFormat == "dd/mm/yyyy")
        this.label = "Day/Month/Year"
      else
        this.label = "Month/Day/Year"
    }
  },
  methods: {
    requestReg() {
      // axios.post('http://localhost/ifrs/register.php', {
      axios.post('http://ifrs.panov.rs/php/register.php', {
        request: 'requestReg',
        name: this.name,
        email: this.email,
        company_name: this.company,
        company_address: this.address,
        vat_number: this.vat,
        registration_number: this.reg
			})
			.then(response => {
				console.log(response)
			})
			.catch(function (error) {
				console.log(error);
			});
    },
    checkForm: function () {
      //required fields
      if (this.name && this.email && this.company && this.vat && this. reg && this.adress) {
        return true;
      }

      this.errors = [];

      if (!this.name) {
        this.errors.push('Name required.');
      }
      if (!this.email) {
        this.errors.push('Email required.');
      } else if (!this.validEmail(this.email)) {
        this.errors.push('Valid email required.');
      }
      if (!this.company) {
        this.errors.push('Company name required.');
      }
      if (!this.vat) {
        this.errors.push('VAT number required.');
      }
      if (!this.reg) {
        this.errors.push('Registration number required.');
      }
      if (!this.address) {
        this.errors.push('Adress required.');
      }

      if (Array.isArray(this.errors) && this.errors.length) {
        console.log("got something in it...:)")
      } else {
        console.log("empty")
        this.requestReg()
      }

    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    checkName() {
      var re = /^[a-zA-Zčćžđš]+$/

      var test = re.test(this.name)
      if(!test) {
        this.name = this.name.replace(this.name.charAt(this.name.length - 1), '')
       
      }
    },
    //regEx email
    isEmailValid() {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return (this.email == "") ? "" : (re.test(this.email)) ? 'success' : 'error'
    },
    // checkMail() {
    //   var re = /[' ]/
    //   var test = re.test(this.email)
    //   if(test) {
    //     this.email = this.email.replace(this.email.charAt(this.email.length - 1), '')
    //   }
    // }
  }
}
</script>

<style scoped>
  /* .bm {
    display: block;
    margin-bottom: 10px;
  } */
  /* .btn {
    margin: auto;
    margin-top: 20px;
    max-width: 200px;
  } */
  /*
  .error {
    color: red;
  }
  */
  /* li {
    list-style-type: none;
  } */
  /*
  .has-error {
    /* border-color: brown; */
    /*
    color: red;
  }
  .has-success {
    color: greenyellow;
  }
  */
</style>